<div class="container-fluid vh-100 d-flex align-items-center justify-content-center">
    <div class="row justify-content-center w-100">
        <div class="col-md-6 col-lg-5">
            <div class="text-center mb-4">
                <img src="/assets/images/logo-2.png" alt="Logo" class="img-fluid mb-4" style="max-width: 200px;">
            </div>
            <div class="card shadow-lg">
                <div class="card-body p-5">
                    <div class="text-center mb-4">
                        <h2 class="fw-bold text-primary">
                            <i class="fa-solid fa-lock-open me-2"></i>
                            Mot de passe oublié ?
                        </h2>
                        <p class="text-muted">
                            Entrez votre adresse email pour recevoir un lien de réinitialisation
                        </p>
                    </div>

                    <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
                        <div class="form-group mb-4">
                            <label for="email" class="form-label">
                                <i class="fa-solid fa-envelope text-primary me-2"></i>
                                Adresse email
                            </label>
                            <input type="email" class="form-control" id="email" formControlName="email"
                                placeholder="Entrez votre email"
                                [class.is-invalid]="forgotPasswordForm.get('email')?.touched && forgotPasswordForm.get('email')?.invalid">

                            <div class="invalid-feedback"
                                *ngIf="forgotPasswordForm.get('email')?.touched && forgotPasswordForm.get('email')?.invalid">
                                <span *ngIf="forgotPasswordForm.get('email')?.errors?.['required']">
                                    L'email est requis
                                </span>
                                <span *ngIf="forgotPasswordForm.get('email')?.errors?.['email']">
                                    Veuillez entrer une adresse email valide
                                </span>
                            </div>
                        </div>

                        <div class="d-grid gap-2">
                            <button type="submit" class="btn btn-primary btn-lg"
                                [disabled]="forgotPasswordForm.invalid || isLoading">
                                <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2" role="status"
                                    aria-hidden="true"></span>
                                Envoyer le lien
                            </button>
                        </div>

                        <div class="text-center mt-4">
                            <a routerLink="/auth/login" class="text-decoration-none">
                                <i class="fa-solid fa-arrow-left me-2"></i>
                                Retour à la connexion
                            </a>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal de succès -->
<div class="modal fade show" *ngIf="showSuccessModal" style="display: block; background-color: rgba(0,0,0,0.5);"
    tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header border-0">
                <button type="button" class="btn-close" (click)="closeModalAndRedirect()"></button>
            </div>
            <div class="modal-body text-center py-4">
                <div class="mb-4">
                    <i class="fa-solid fa-circle-check text-success" style="font-size: 4rem;"></i>
                </div>
                <h3 class="fw-bold text-primary mb-3">Email envoyé !</h3>
                <p class="text-muted mb-4">
                    Un email de réinitialisation a été envoyé à votre adresse <strong>{{ forgotPasswordForm.value.email
                        }}</strong>.
                    <br><br>
                    Veuillez vérifier votre boîte de réception et suivre les instructions pour réinitialiser votre mot
                    de passe.
                </p>
            </div>
            <div class="modal-footer border-0 justify-content-center">
                <button type="button" class="btn btn-primary px-5" (click)="closeModalAndRedirect()">
                    <i class="fa-solid fa-arrow-left me-2"></i>
                    Retour à la connexion
                </button>
            </div>
        </div>
    </div>
</div>

<style>
    .card {
        border: none;
        border-radius: 15px;
    }

    .form-control {
        border-radius: 10px;
        padding: 12px;
        border: 1px solid #e0e0e0;
    }

    .form-control:focus {
        box-shadow: 0 0 0 0.2rem rgba(3, 137, 201, 0.25);
        border-color: #0389C9;
    }

    .btn-primary {
        background-color: #0389C9;
        border-color: #0389C9;
        border-radius: 10px;
        padding: 12px;
        font-weight: 500;
    }

    .btn-primary:hover {
        background-color: #0277b3;
        border-color: #0277b3;
    }

    .btn-primary:disabled {
        background-color: #0389C9;
        border-color: #0389C9;
        opacity: 0.7;
    }

    .text-primary {
        color: #0389C9 !important;
    }

    .container-fluid {
        background-color: #f8f9fa;
    }

    .img-fluid {
        max-width: 200px;
        height: auto;
    }

    .modal.show {
        display: block;
    }

    .modal-content {
        border-radius: 15px;
        border: none;
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
    }
</style>